'use strict';

module.exports = {
	arrowLeft: require('./arrowLeft'),
	arrowRight: require('./arrowRight'),
	close: require('./close')
};


//////////////////
// WEBPACK FOOTER
// ./~/react-images/lib/icons/index.js
// module id = 253
// module chunks = 0